import { render, staticRenderFns } from "./FamilyFormular.vue?vue&type=template&id=74c6fc99"
import script from "./FamilyFormular.vue?vue&type=script&lang=js"
export * from "./FamilyFormular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports